import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import IconButton from "@mui/material/IconButton";
import SyncIcon from "@mui/icons-material/Sync";
import { productAction } from "../../actions";
import { Box, Tooltip } from "@mui/material";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import SortIcon from "@mui/icons-material/Sort";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Button from "@mui/material/Button";
import Api from "../../utils/api";
import { toast } from "react-toastify";
import CurrencyFormat from "react-currency-format";
import HeadLine from "../../components/HeadLine/headLine";
import ReactPaginate from "react-paginate";
import GetAppIcon from "@mui/icons-material/GetApp";
import UpdateIcon from "@mui/icons-material/Update";

const ProductCrawler = (props) => {
  const { fetchCrawlerProducts, productReducer } = props;

  const [page, setPage] = useState(1);
  const [sort_field, setSortField] = useState("product_id");
  const [sort_type, setSortType] = useState("desc");
  const [limit, setLimit] = useState(50);
  const [crawlerData, setCrawlerData] = useState([]);
  const [totalData, setTotalData] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const [filter, setFilter] = useState({
    product_id: "",
    title: "",
  });

  useEffect(() => {
    handleRequest();
  }, [sort_field, sort_type, limit, page, filter]);

  const handleChangeSearchInput = (event) => {
    setPage(1);
    let search = filter;
    search[event.target.name] = event.target.value;
    setFilter({ ...search });
  };

  const handleRequest = () => {
    setIsLoading(true);
    new Api()
      .get("/products/crawler/products", {
        filter,
        sort_field: sort_field,
        sort_type: sort_type,
        page: page,
        limit: limit,
      })
      .then((response) => {
        if (typeof response !== "undefined") {
          setCrawlerData(response.data || response);
          setTotalData(response.total || response.length);
          setIsLoading(false);
        }
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  const handleExportExcel = () => {
    new Api()
      .get(
        "/products/crawler/excel_export",
        {
          filter,
        },
        {
          responseType: "blob",
        }
      )
      .then((response) => {
        if (typeof response !== "undefined") {
          const url = window.URL.createObjectURL(new Blob([response]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `crawler-products-${Date.now()}.xlsx`);
          document.body.appendChild(link);
          link.click();
          link.remove();
          toast.success("خروجی اکسل با موفقیت دریافت شد");
        }
      })
      .catch(() => {
        toast.error("خطا در دریافت فایل اکسل");
      });
  };

  const handleUpdatePrice = (productId) => {
    // این API بعدا اضافه میشه
    toast.info("این قابلیت به زودی فعال می‌شود");
    // new Api().post(`/products/${productId}/update-price-from-crawler`).then((response) => {
    //     if (typeof response !== "undefined" && response.status) {
    //         toast.success('قیمت با موفقیت به‌روزرسانی شد');
    //         handleRequest();
    //     }
    // })
  };

  const pageCount = Math.ceil(totalData / limit);

  const getColorStyle = (color) => {
    const colors = {
      green: "#4caf50",
      yellow: "#ff9800",
      red: "#f44336",
    };
    return {
      backgroundColor: colors[color] || "#fff",
      padding: "2px 8px",
      borderRadius: "4px",
      color: "#fff",
    };
  };

  return (
    <div style={{ padding: "0 20px" }}>
      <HeadLine
        title={"کرولر قیمت محصولات"}
        subTitle={"مقایسه قیمت‌ها با سایت‌های رقیب"}
      />
      <Box style={{ margin: "20px 0" }} boxShadow={0}>
        <Accordion defaultExpanded={false}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1c-content"
            id="panel1c-header"
          >
            <div>
              <Typography>جستجو</Typography>
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4} md={3}>
                <TextField
                  id="product-id"
                  type={"search"}
                  label="کد محصول"
                  variant="outlined"
                  margin="dense"
                  fullWidth
                  name="product_id"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={handleChangeSearchInput}
                  value={filter.product_id}
                />
              </Grid>
              <Grid item xs={12} sm={4} md={3}>
                <TextField
                  id="product-title"
                  type={"search"}
                  label="نام محصول"
                  variant="outlined"
                  margin="dense"
                  fullWidth
                  name="title"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={handleChangeSearchInput}
                  value={filter.title}
                />
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Box>

      <Box style={{ margin: "20px 0" }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <ReactPaginate
              previousLabel={"<"}
              nextLabel={">"}
              breakLabel={"..."}
              pageCount={pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={(selectedItem) =>
                setPage(selectedItem.selected + 1)
              }
              containerClassName={"pagination"}
              activeClassName={"active"}
            />
          </Grid>
        </Grid>
      </Box>

      <div
        style={{
          display: "flex",
          direction: "row",
          justifyContent: "flex-end",
          marginBottom: "10px",
        }}
      >
        <Tooltip title="دانلود اکسل">
          <IconButton onClick={handleExportExcel} color="primary">
            <GetAppIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="بروزرسانی" onClick={() => handleRequest()}>
          <IconButton>
            <SyncIcon />
          </IconButton>
        </Tooltip>
      </div>

      <>
        <div style={{ overflowX: "auto" }}>
          <table className="table">
            <thead>
              <tr>
                <th
                  onClick={() => {
                    setSortType(sort_type === "asc" ? "desc" : "asc");
                    setSortField("product_id");
                  }}
                >
                  کد محصول&nbsp;
                  {sort_field === "product_id" ? (
                    sort_type === "desc" ? (
                      <ArrowDownwardIcon />
                    ) : (
                      <ArrowUpwardIcon />
                    )
                  ) : (
                    <SortIcon />
                  )}
                </th>
                <th
                  onClick={() => {
                    setSortType(sort_type === "asc" ? "desc" : "asc");
                    setSortField("title");
                  }}
                >
                  نام محصول&nbsp;
                  {sort_field === "title" ? (
                    sort_type === "desc" ? (
                      <ArrowDownwardIcon />
                    ) : (
                      <ArrowUpwardIcon />
                    )
                  ) : (
                    <SortIcon />
                  )}
                </th>
                <th>قیمت فعلی (تومان)</th>
                <th>واحد محصول</th>
                <th>منابع کرول شده</th>
                <th>عملیات</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr>
                  <td
                    colSpan="6"
                    style={{ textAlign: "center", padding: "20px" }}
                  >
                    در حال بارگذاری...
                  </td>
                </tr>
              ) : crawlerData && crawlerData.length > 0 ? (
                crawlerData.map((entity, index) => {
                  return (
                    <tr key={index}>
                      <td>{entity.product_id}</td>
                      <td>
                        <b>{entity.title}</b>
                      </td>
                      <td>
                        <CurrencyFormat
                          value={entity.price_details?.main_price || 0}
                          displayType={"text"}
                          thousandSeparator={true}
                        />
                        <br />
                        <small style={{ color: "#666" }}>
                          ({entity.price_details?.product_unit || "-"})
                        </small>
                      </td>
                      <td>{entity.price_details?.main_unit || "-"}</td>
                      <td>
                        {entity.suppliers_prices &&
                        Object.keys(entity.suppliers_prices).length > 0 ? (
                          <table
                            style={{
                              width: "100%",
                              borderCollapse: "collapse",
                            }}
                          >
                            <thead>
                              <tr>
                                <th
                                  style={{
                                    border: "1px solid #ddd",
                                    padding: "8px",
                                    backgroundColor: "#f5f5f5",
                                  }}
                                >
                                  منبع
                                </th>
                                <th
                                  style={{
                                    border: "1px solid #ddd",
                                    padding: "8px",
                                    backgroundColor: "#f5f5f5",
                                  }}
                                >
                                  اختلاف
                                </th>
                                <th
                                  style={{
                                    border: "1px solid #ddd",
                                    padding: "8px",
                                    backgroundColor: "#f5f5f5",
                                  }}
                                >
                                  قیمت
                                </th>
                                <th
                                  style={{
                                    border: "1px solid #ddd",
                                    padding: "8px",
                                    backgroundColor: "#f5f5f5",
                                  }}
                                >
                                  نام محصول
                                </th>
                                <th
                                  style={{
                                    border: "1px solid #ddd",
                                    padding: "8px",
                                    backgroundColor: "#f5f5f5",
                                  }}
                                >
                                  شباهت
                                </th>
                                <th
                                  style={{
                                    border: "1px solid #ddd",
                                    padding: "8px",
                                    backgroundColor: "#f5f5f5",
                                  }}
                                >
                                  تاریخ
                                </th>
                                <th
                                  style={{
                                    border: "1px solid #ddd",
                                    padding: "8px",
                                    backgroundColor: "#f5f5f5",
                                  }}
                                >
                                  لینک
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {Object.keys(entity.suppliers_prices).map(
                                (supplier, idx) => {
                                  const supplierData =
                                    entity.suppliers_prices[supplier];
                                  return (
                                    <tr key={idx}>
                                      <td
                                        style={{
                                          border: "1px solid #ddd",
                                          padding: "6px",
                                        }}
                                      >
                                        <strong>{supplier}</strong>
                                      </td>
                                      <td
                                        style={{
                                          border: "1px solid #ddd",
                                          padding: "6px",
                                        }}
                                      >
                                        <span
                                          style={getColorStyle(
                                            supplierData.color
                                          )}
                                        >
                                          {supplierData.difference_percent
                                            ? `${supplierData.difference_percent.toFixed(
                                                2
                                              )}%`
                                            : "-"}
                                        </span>
                                      </td>
                                      <td
                                        style={{
                                          border: "1px solid #ddd",
                                          padding: "6px",
                                        }}
                                      >
                                        <CurrencyFormat
                                          value={
                                            supplierData.crawled_price || 0
                                          }
                                          displayType={"text"}
                                          thousandSeparator={true}
                                        />
                                      </td>
                                      <td
                                        style={{
                                          border: "1px solid #ddd",
                                          padding: "6px",
                                          fontSize: "11px",
                                        }}
                                      >
                                        {supplierData.source_real_product_name ||
                                          "-"}
                                      </td>
                                      <td
                                        style={{
                                          border: "1px solid #ddd",
                                          padding: "6px",
                                          fontSize: "11px",
                                        }}
                                      >
                                        {supplierData.similarity || "-"}%
                                      </td>
                                      <td
                                        style={{
                                          border: "1px solid #ddd",
                                          padding: "6px",
                                          fontSize: "11px",
                                        }}
                                      >
                                        {supplierData.crawled_date
                                          ? new Date(
                                              supplierData.crawled_date
                                            ).toLocaleDateString("fa-IR")
                                          : "-"}
                                      </td>
                                      <td
                                        style={{
                                          border: "1px solid #ddd",
                                          padding: "6px",
                                        }}
                                      >
                                        {supplierData.link && (
                                          <a
                                            href={supplierData.link}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ fontSize: "11px" }}
                                          >
                                            مشاهده
                                          </a>
                                        )}
                                      </td>
                                    </tr>
                                  );
                                }
                              )}
                            </tbody>
                          </table>
                        ) : (
                          <span style={{ color: "#999" }}>
                            اطلاعاتی موجود نیست
                          </span>
                        )}
                      </td>
                      <td>
                        <Tooltip title="به‌روزرسانی قیمت">
                          <IconButton
                            color="primary"
                            onClick={() => handleUpdatePrice(entity.product_id)}
                            size="small"
                          >
                            <UpdateIcon />
                          </IconButton>
                        </Tooltip>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td
                    colSpan="6"
                    style={{ textAlign: "center", padding: "20px" }}
                  >
                    موردی یافت نشد
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <ReactPaginate
          previousLabel={"<"}
          nextLabel={">"}
          breakLabel={"..."}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={(selectedItem) => setPage(selectedItem.selected + 1)}
          containerClassName={"pagination"}
          activeClassName={"active"}
        />
      </>
    </div>
  );
};

const mapStateToProps = (state) => ({
  productReducer: state.productReducer,
});

const mapDispatchToProps = (dispatch) => ({
  fetchCrawlerProducts: (object) => {
    dispatch(productAction.fetchCrawlerProducts(object));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductCrawler);
